import { toOptions } from 'utils/toOptions';

import { useGetPoolMaintenanceTableData } from '../../../../Pools/PoolMaintenance/hooks/useGetPoolMaintenanceTableData';
import { useSelector } from 'hooks';
import { UseQueryOptions } from 'react-query';

export const useGetPoolOptions = (
  options?: UseQueryOptions<any, unknown, any>
) => {
  const hasPoolOrganizationGrant = useSelector(
    (state) => state.grants.hasPoolsOrgGrant
  );
  const { data, ...getPoolMaintenanceTableData } =
    useGetPoolMaintenanceTableData({
      enabled: hasPoolOrganizationGrant,
      ...options
    });

  return {
    ...getPoolMaintenanceTableData,
    data: toOptions(data ?? [], 'id', 'name')
  };
};
